import {
  type ApiProblemDetails,
  getPayPointsPublicID,
  type InternalPayPointDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { skipToken, useQuery } from "@tanstack/react-query";

const PAY_POINT_QUERY_KEY = "PAY_POINT";

export const payPointKeys = {
  all: [PAY_POINT_QUERY_KEY],
  byId: (publicID?: string | null) => [...payPointKeys.all, publicID],
};

export const usePayPointQuery = (publicID?: string | null) =>
  useQuery<InternalPayPointDto, ApiProblemDetails, InternalPayPointDto>({
    queryKey: payPointKeys.byId(publicID),
    queryFn: publicID
      ? processResponseWithApiProblemDetails(() =>
          getPayPointsPublicID(publicID),
        )
      : skipToken,
    enabled: !!publicID,
  });
